var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSelect1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 125,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 124,
    rx: 9.5,
    fill: "#FDFDFD",
    stroke: "#A3A3A3",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 51c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12Zm0-2c7.7 0 14 6.3 14 14s-6.3 14-14 14-14-6.3-14-14 6.3-14 14-14Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 62h7v-7h2v7h7v2h-7v7h-2v-7h-7v-2Z",
    fill: "#CCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSelect1);
export default __webpack_public_path__ + "static/media/img_select1.54cd7926ed8ef9105dca7066370b44b6.svg";
export { ForwardRef as ReactComponent };